module.exports = __webpack_public_path__ + "static/media/calendario-hombre-izquierda.7b243e07.png";